module.exports = __webpack_public_path__ + "static/img/a8c9f4d78e7480721cc2b038db9e6dc.494246af.jpg";